import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useState } from 'react';

import PAPopover from '@/components/popover';
import { useTranslation } from '@/i18n/client';

import type { TabItem, ViewTabsEnum } from '../../constants';
import { TabIconMap, ViewTabsNameTranslationMap } from '../../constants';
import styles from './index.less';

interface IMenuTab {
  item: TabItem;
  activeTab: string;
  onClickTab: (v: ViewTabsEnum) => void;
}

export default function MenuTab(props: IMenuTab): JSX.Element {
  const { item, activeTab, onClickTab } = props;
  const isActive = item.key === activeTab;
  const [dotShow, setDotShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState<string>('');

  const { t } = useTranslation();

  const closeTip = () => {
    setOpen(false);
    setTitle('');
  };

  const closeDot = () => {
    setDotShow(false);
    closeTip();
  };

  const tabClk = (tab: TabItem) => {
    if (dotShow) {
      closeDot();
    }

    onClickTab(tab.key);
  };

  return (
    <div
      key={item.key}
      className={classNames(styles.tabItem, {
        [styles.active]: isActive
      })}
      data-role="edit-ignore-blur"
      id={item.id}
      onClick={() => {
        tabClk(item);
      }}
    >
      <PAPopover
        key={item.key}
        content={title}
        open={open}
        overlayClassName={styles.overlayClassNameMenuTip}
        placement="right"
      >
        {item.name === 'Talks' ? (
          <div className={styles.tabIcon}>
            {dotShow && <div className={styles.dot} />}
            <Icon className={styles.icon} component={TabIconMap[item.key]} />
          </div>
        ) : (
          <div className={styles.tabIcon}>
            {dotShow && <div className={styles.dot} />}
            <Icon className={styles.icon} component={TabIconMap[item.key]} />
          </div>
        )}
      </PAPopover>
      <h3 className={styles.title}>{t(ViewTabsNameTranslationMap[item.key])}</h3>
    </div>
  );
}
